// src/utils/deepLink.ts
//
// Cross-tab deep-link hand-off. Opening a new browser tab cold-boots the SPA,
// and Keycloak `check-sso` redirects through the auth server with a redirect_uri
// of `origin/` — an OAuth redirect_uri cannot carry a URL fragment, so the
// intended hash route (e.g. `#/events?filter=...`) is lost and the tab lands on
// the dashboard. To preserve the destination we stash it in localStorage — before
// opening the tab, or before the sign-in redirect of a reload — and the boot
// (index.tsx) restores it once the session is back, before the router starts.

const KEY = 'insight.pendingDeepLink.v1';
const TTL_MS = 30_000;

/** Remember the in-app route to land on once a freshly-opened tab has booted. */
export const stashDeepLink = (route: string): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ route, ts: Date.now() }));
  } catch {
    /* ignore quota / privacy-mode errors */
  }
};

/** Read-and-clear the pending deep link, if any and still fresh. */
export const consumeDeepLink = (): string | null => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.route !== 'string') return null;
    if (typeof parsed.ts !== 'number' || Date.now() - parsed.ts > TTL_MS) return null;
    return parsed.route;
  } catch {
    return null;
  }
};
